import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ReportsLayout from "../pages/reports/ReportsLayout";
import SalesReports from "../pages/reports/SalesReports";
import OrdersReports from "../pages/reports/OrdersReports";
import MenuReports from "../pages/reports/MenuReports";
import CustomerReports from "../pages/reports/CustomerReports";
import FinancialReports from "../pages/reports/FinancialReports";
import StoreReports from "../pages/reports/StoreReports";
import ForecastReports from "../pages/reports/ForecastReports";

const ReportsRoutes = () => (
  <Routes>
    <Route element={<ReportsLayout />}>
      <Route index element={<Navigate to="/reports/sales" replace />} />
      <Route path="sales" element={<SalesReports />} />
      <Route path="orders" element={<OrdersReports />} />
      <Route path="menu" element={<MenuReports />} />
      <Route path="customers" element={<CustomerReports />} />
      <Route path="financial" element={<FinancialReports />} />
      <Route path="store" element={<StoreReports />} />
      <Route path="forecast" element={<ForecastReports />} />
      <Route path="*" element={<Navigate to="/reports/sales" replace />} />
    </Route>
  </Routes>
);

export default ReportsRoutes;
